import { api } from '@/lib/api';
import type {
  CreateGroomingPackageInput,
  GroomingPackage,
  UpdateGroomingPackageInput,
} from './types';

const BASE = '/vendor/grooming/packages';

export async function fetch_grooming_packages(): Promise<GroomingPackage[]> {
  const res = await api.get<GroomingPackage[]>(BASE);
  return res.data;
}

/** Public: a salon's active grooming packages (tiers), for the booking surface. */
export async function fetch_public_grooming_packages(vendor_id: string): Promise<GroomingPackage[]> {
  const res = await api.get<GroomingPackage[]>(`/user/vendors/${vendor_id}/grooming/packages`);
  return res.data;
}

export async function create_grooming_package(
  input: CreateGroomingPackageInput,
): Promise<GroomingPackage> {
  const res = await api.post<GroomingPackage>(BASE, input);
  return res.data;
}

export async function update_grooming_package(
  id: string,
  input: UpdateGroomingPackageInput,
): Promise<GroomingPackage> {
  const res = await api.patch<GroomingPackage>(`${BASE}/${id}`, input);
  return res.data;
}

export async function delete_grooming_package(id: string): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}
